<div class="update-cola-info-dialog">
  <div class="dialog-header">
    <h2>Update COLA Info</h2>
  </div>

  <ptg-banner [bannerType]="bannerType" [message]="message"></ptg-banner>

  <form [formGroup]="form" class="cola-form">
    <div class="form-actions">
      <ptg-button
        [buttonName]="'Save'"
        [isDisabled]="isSaving"
        classInput="primary"
        (clickButton)="onSubmit()"
      ></ptg-button>
      <ptg-button
        [buttonName]="'Cancel'"
        [isDisabled]="isSaving"
        classInput="tertiary"
        (clickButton)="onCancel()"
      ></ptg-button>

    </div>

    <div class="form-content">
      <div class="form-group">
        <ptg-textbox
          [controlField]="form.get('annualCola')"
          placeholder="Enter annual COLA"
          [hasLabel]="true"
          [isRequired]="true"
          type="number"
        ></ptg-textbox>
        <div class="error-message" *ngIf="form.get('annualCola')?.invalid && form.get('annualCola')?.touched">
          <small *ngIf="form.get('annualCola')?.errors?.['required']">Annual COLA is required</small>
          <small *ngIf="form.get('annualCola')?.errors?.['pattern']">Please enter a valid number with up to 2 decimal places</small>
        </div>
      </div>

      <div class="form-group">
        <ptg-datepicker
          controlName="colaEligibleDate"
          placeholder="Select a date"
          [controlField]="form.get('colaEligibleDate')"
          [minDate]="minDate"
          [isRequired]="true"
        ></ptg-datepicker>
        <div class="error-message" *ngIf="form.get('colaEligibleDate')?.invalid && form.get('colaEligibleDate')?.touched">
          <small *ngIf="form.get('colaEligibleDate')?.errors?.['required']">COLA Eligible Date is required</small>
        </div>
      </div>
    </div>


  </form>
</div>
